import { useAtomValue } from 'jotai'
import React from 'react'

import { surveyFilterAtom } from '~/atoms'
import { useCurrentSurvey } from '~/hooks/useCurrentSurvey'

/**
 * サンプルサイズを返すカスタムフックです。
 *
 * @returns サンプルサイズ。
 */
export const useSampleSize = () => {
  const surveyFilter = useAtomValue(surveyFilterAtom)
  const currentSurvey = useCurrentSurvey()

  return React.useMemo(() => {
    const numberOfTotalAnswers = currentSurvey.success
      ? currentSurvey.value.numberOfTotalAnswers
      : undefined

    return surveyFilter?.count ?? numberOfTotalAnswers ?? NaN
  }, [currentSurvey, surveyFilter?.count])
}
